import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Me from "./pages/Me";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        
        {/* UBAH BAGIAN INI */}
        {/* Dari "/me" menjadi "/info" atau apapun yang kamu mau */}
        <Route path="/info" element={<Me />} /> 
        
      </Routes>
    </BrowserRouter>
  );
}

export default App;